"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountType = exports.AccountStatus = void 0;
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["NotVerified"] = "not:verified";
    AccountStatus["Verified"] = "verified";
    AccountStatus["Selling"] = "selling";
    AccountStatus["Unrecognized"] = "unrecognized";
})(AccountStatus || (exports.AccountStatus = AccountStatus = {}));
var AccountType;
(function (AccountType) {
    AccountType["Member"] = "member";
    AccountType["Supplier"] = "supplier";
    AccountType["Unrecognized"] = "unrecognized";
})(AccountType || (exports.AccountType = AccountType = {}));
